import React from 'react'

const DialogChangeCoordinatorError = () => {
  return (
    <div>
      <p className="mb-4">Este rol te permite gestionar todos los usuarios y formularios de la entidad.</p>
      <div>
        <p>Si te quitas este rol, perderás el acceso y ya no podrás:</p>
        <ul className="list-disc ml-4 mb-4">
          <li>Crear o editar usuarios</li>
          <li>Asignar formularios</li>
          <li>Recuperar tu acceso como coordinador</li>
        </ul>
      </div>
      <p>
        Solo alguien con el mismo rol podrá devolvértelo. Si no hay nadie más asignado, deberás solicitarlo otra vez al
        correo <a href="mailto:mesadeayuda@gobiernodigital.gob.pe">mesadeayuda@gobiernodigital.gob.pe</a>
      </p>
    </div>
  )
}

export default DialogChangeCoordinatorError
